import React from 'react';
import ChangePasswordForm from './ChangePasswordFormContainer';
var ChangePassword = function ChangePassword(_ref) {
  var userIdentity = _ref.userIdentity;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-8"
  }, /*#__PURE__*/React.createElement(ChangePasswordForm, {
    userIdentity: userIdentity
  }));
};
export default ChangePassword;